// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../../../styles/media'
import Card from '../../../../components/Card'

const Component = styled.div`
  width: 100%;
  padding: 0 1rem;

  ${media.mdUp} {
    width: 50%;
  }
`

const randomWidth = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min)

const Line = styled.div`
  background: rgb(245, 248, 251);
  margin-bottom: 2px;
`

const LoadingResult = () => (
  <Component>
    <Card>
      <div className="row">
        <div className="col-md-6 col-xs-12">
          <div
            style={{
              width: '100%',
              height: '280px',
              background: 'rgb(245,248,251)'
            }}
          />
        </div>
        <div className="col-md-6 col-xs-12">
          <div style={{ marginBottom: '10px' }}>
            <Line
              style={{ height: '24px', width: `${randomWidth(60, 100)}%` }}
            />
            <Line
              style={{ height: '15px', width: `${randomWidth(60, 100)}%` }}
            />
          </div>
          <Line style={{ height: '24px', width: `${randomWidth(60, 100)}%` }} />
          <hr style={{ borderColor: 'rgb(245,248,251)' }} />
          <Line style={{ height: '18px', width: `${randomWidth(60, 100)}%` }} />
          <Line style={{ height: '18px', width: `${randomWidth(60, 100)}%` }} />
          <Line style={{ height: '18px', width: `${randomWidth(60, 100)}%` }} />
          <Line style={{ height: '18px', width: `${randomWidth(60, 100)}%` }} />
          <hr style={{ borderColor: 'rgb(245,248,251)' }} />
          <Line style={{ height: '15px', width: `${randomWidth(60, 100)}%` }} />
        </div>
      </div>
    </Card>
  </Component>
)

export default LoadingResult



// WEBPACK FOOTER //
// ./src/views/Search/components/LoadingResult/index.js